/**
 * Mobile Debug Helper
 * Hiển thị debug info ngay trên mobile screen
 */

// Tạo debug panel floating trên màn hình
export const initMobileDebug = () => {
  if (typeof window === 'undefined') return;

  // Chỉ chạy khi có query param ?debug=1
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.get('debug')) return;

  // Tạo debug panel
  const panel = document.createElement('div');
  panel.id = 'mobile-debug-panel';
  panel.style.cssText = `
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-height: 300px;
    background: rgba(0, 0, 0, 0.9);
    color: #0f0;
    font-family: monospace;
    font-size: 11px;
    padding: 10px;
    overflow-y: auto;
    z-index: 99999;
    border-bottom: 2px solid #0f0;
  `;

  // Thêm toggle button
  const toggleBtn = document.createElement('button');
  toggleBtn.textContent = '📱 Debug';
  toggleBtn.style.cssText = `
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 100000;
    background: #000;
    color: #0f0;
    border: 1px solid #0f0;
    padding: 8px 12px;
    border-radius: 4px;
    font-weight: bold;
  `;

  let isVisible = true;
  toggleBtn.onclick = () => {
    isVisible = !isVisible;
    panel.style.display = isVisible ? 'block' : 'none';
    toggleBtn.textContent = isVisible ? '📱 Debug' : '📱 Show';
  };

  document.body.appendChild(panel);
  document.body.appendChild(toggleBtn);

  // Log function
  const log = (msg, type = 'info') => {
    const time = new Date().toLocaleTimeString();
    const color = {
      info: '#0f0',
      warn: '#ff0',
      error: '#f00',
      success: '#0ff'
    }[type] || '#0f0';

    const line = document.createElement('div');
    line.style.color = color;
    line.textContent = `[${time}] ${msg}`;
    panel.appendChild(line);

    // Auto scroll to bottom
    panel.scrollTop = panel.scrollHeight;

    // Keep last 50 lines only
    if (panel.children.length > 50) {
      panel.removeChild(panel.firstChild);
    }
  };

  // Export log function
  window.mobileLog = log;

  // Initial info
  log('=== Mobile Debug Panel ===', 'success');
  log(`User Agent: ${navigator.userAgent}`);
  log(`Platform: ${navigator.platform}`);
  log(`Online: ${navigator.onLine}`);

  // Check localStorage
  try {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');

    log('--- LocalStorage Check ---', 'warn');
    log(`Token exists: ${!!token}`);
    if (token) {
      log(`Token length: ${token.length}`);
      log(`Token preview: ${token.substring(0, 30)}...`);
    }
    log(`User exists: ${!!user}`);
    if (user) {
      const userData = JSON.parse(user);
      log(`User ID: ${userData.id}`);
      log(`Username: ${userData.username}`);
      log(`Role: ${userData.role}`);
    }
  } catch (e) {
    log(`localStorage error: ${e.message}`, 'error');
  }

  // Override console methods để capture logs
  const originalLog = console.log;
  const originalError = console.error;
  const originalWarn = console.warn;

  console.log = (...args) => {
    originalLog(...args);
    log(args.map(a => typeof a === 'object' ? JSON.stringify(a) : a).join(' '), 'info');
  };

  console.error = (...args) => {
    originalError(...args);
    log(args.map(a => typeof a === 'object' ? JSON.stringify(a) : a).join(' '), 'error');
  };

  console.warn = (...args) => {
    originalWarn(...args);
    log(args.map(a => typeof a === 'object' ? JSON.stringify(a) : a).join(' '), 'warn');
  };

  // Monitor axios requests
  if (window.axios) {
    log('Axios detected, adding interceptors...', 'success');
  }

  return {
    log,
    clear: () => { panel.innerHTML = ''; },
    hide: () => { panel.style.display = 'none'; },
    show: () => { panel.style.display = 'block'; }
  };
};

// Auto init nếu có ?debug=1
if (typeof window !== 'undefined') {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('debug')) {
    window.addEventListener('DOMContentLoaded', initMobileDebug);
  }
}
